import { Wallet } from "lucide-react";
import { useState } from "react";
import useCheckIsMobile from "../lesson/lessonRefactor/utils/useCheckIsMobile";
import { LessonDataI, LiveSessionDataI } from "../quiz/typesAndEnums";
import CodePurchase from "./purchaseMethods/CodePurchase";
import FawryPurchase from "./purchaseMethods/FawryPurchase";
import FreePurchase from "./purchaseMethods/FreePurchase";
import MobileWalletPurchase from "./purchaseMethods/MobileWalletPurchase";
import WalletPurchase from "./purchaseMethods/WalletPurchase";

export enum PurchaseMethods {
  CODE = "code",
  WALLET = "wallet",
  FAWRY = "fawry",
  MOBILE_WALLET = "mobileWallet",
}
const Purchase = ({
  lessonData,
  isRepurchase = false,
}: {
  lessonData: LessonDataI | LiveSessionDataI;
  isRepurchase?: boolean;
}) => {
  const [purchaseBlock, setPurchaseBlock] = useState(null);
  const [paymentMethodsOpen, setPaymentMethodsOpen] = useState(false);
  const { isMobile } = useCheckIsMobile();

  if (lessonData.price === 0) return <FreePurchase lessonData={lessonData} />;

  return (
    <div className="purchase-lesson bg-white container mx-auto sm:max-w-2/3 rounded-2xl p-4">
      {!isRepurchase && (
        <div className="flex">
          <img
            className={`mx-auto  ${isMobile ? "w-full" : "w-2/3"}`}
            src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/buy-now.png"
            alt="اشتري الان"
          />
        </div>
      )}

      <div className="flex">
        <div className="w-full mx-auto">
          <div className="mx-auto rounded-lg border border-gray-300 px-4 py-3 bg-gray-50 max-w-md text-center">
            <p
              className="font-bold text-lg cursor-pointer"
              onClick={() => {
                setPaymentMethodsOpen(!paymentMethodsOpen);
                if (paymentMethodsOpen) setPurchaseBlock(null);
              }}
            >
              اختر وسيلة الدفع
            </p>

            {paymentMethodsOpen && (
              <>
                <div className="border-b my-3"></div>

                {lessonData.code && (
                  <p
                    className={`cursor-pointer p-3 rounded-lg hover:bg-gray-200 flex gap-2 justify-start items-center ${
                      purchaseBlock === PurchaseMethods.CODE
                        ? "text-ea-primary font-bold"
                        : ""
                    }`}
                    onClick={() => setPurchaseBlock(PurchaseMethods.CODE)}
                  >
                    كود
                    <img
                      className="inline-block h-4 bg-white rounded-sm"
                      src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/code-purchase.webp"
                      alt="كود"
                    />
                  </p>
                )}

                {lessonData.wallet && (
                  <p
                    className={`cursor-pointer p-3 rounded-lg hover:bg-gray-200 flex gap-2 justify-start items-center ${
                      purchaseBlock === PurchaseMethods.WALLET
                        ? "text-ea-primary font-bold"
                        : ""
                    }`}
                    onClick={() => setPurchaseBlock(PurchaseMethods.WALLET)}
                  >
                    رصيد المحفظة
                    <Wallet className="text-primary" />
                  </p>
                )}

                {lessonData.fawry && (
                  <p
                    className={`cursor-pointer p-3 rounded-lg hover:bg-gray-200 flex gap-2 justify-start items-start ${
                      purchaseBlock === PurchaseMethods.FAWRY
                        ? "text-ea-primary font-bold"
                        : ""
                    }`}
                    onClick={() => setPurchaseBlock(PurchaseMethods.FAWRY)}
                  >
                    فوري
                    <img
                      className="size-7 aspect-square"
                      src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/fawry.svg"
                      alt="فوري"
                    />
                  </p>
                )}

                {lessonData.vodafone_cash && (
                  <p
                    className={`cursor-pointer py-3 px-1 rounded-lg hover:bg-gray-200 flex gap-2 justify-start items-center ${
                      purchaseBlock === PurchaseMethods.MOBILE_WALLET
                        ? "text-ea-primary font-bold"
                        : ""
                    }`}
                    onClick={() =>
                      setPurchaseBlock(PurchaseMethods.MOBILE_WALLET)
                    }
                  >
                    محفظة إلكترونية
                    <ul className="flex flex-wrap justify-start gap-2 mt-2">
                      <li className="flex gap-2 flex-wrap justify-center items-center">
                        <img
                          className="w-14 h-7 aspect-square"
                          src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/vodafonechash.png"
                          alt="فودافون كاش"
                        />
                        <img
                          className="w-14 h-9 aspect-square"
                          src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/etisalat.png"
                          alt="اتصالات"
                        />
                        <img
                          className="w-10 h-8 aspect-square"
                          src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/orange-cash.png"
                          alt="اورانج كاش"
                        />
                        <img
                          className="size-10 aspect-square"
                          src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/ahlybank.png"
                          alt="البنك الاهلي"
                        />
                        <img
                          className="size-10 aspect-square"
                          src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/cibwallet.png"
                          alt="CIB Wallet"
                        />
                      </li>
                    </ul>
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div className="w-full mt-4">
        {purchaseBlock === PurchaseMethods.CODE && (
          <CodePurchase lessonData={lessonData} isMobile={isMobile} />
        )}
        {purchaseBlock === PurchaseMethods.WALLET && (
          <WalletPurchase lessonData={lessonData} />
        )}
        {purchaseBlock === PurchaseMethods.FAWRY && (
          <FawryPurchase lesson_id={lessonData.lesson_id} />
        )}
        {purchaseBlock === PurchaseMethods.MOBILE_WALLET && (
          <MobileWalletPurchase lesson_id={lessonData.lesson_id} />
        )}
      </div>
    </div>
  );
};

export default Purchase;
